// extracted by mini-css-extract-plugin
module.exports = {"QuantityButton":"QuantityButton_QuantityButton__2qpRk","increment":"QuantityButton_increment__1Bgsm","decrement":"QuantityButton_decrement__iEqo5"};